import { render, staticRenderFns } from "./AutomaticMessages.vue?vue&type=template&id=12c10548"
import script from "./AutomaticMessages.vue?vue&type=script&lang=ts"
export * from "./AutomaticMessages.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports